export default "__VITE_ASSET__DNeFNtYI__"